import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const MaterialCategoryList = Loadable(lazy(() => import('./MaterialCategoryList')));
const AddMaterialCategory = Loadable(lazy(() => import('./AddMaterialCategory')));

const MaterialCategoryRoutes = [
  {
    path: '/MaterialCategory/list',
    element: <MaterialCategoryList />,
    auth: authRoles.admin,
  },
  {
    path: '/MaterialCategory/manage',
    element: <AddMaterialCategory />,
    auth: authRoles.admin,
  },
];

export default MaterialCategoryRoutes;
